import { ChangeEvent, useEffect, useState } from "react";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import ContainerComponent from "../../components/conatiner";
import HeaderComponent from "../../components/header";
import InputComponent from "../../components/input";
import TableComponent from "../../components/table";
import ModalComponent from "../../components/modal";
import { ToastErro, ToastSucesso } from "../../components/toast";
import { IFinancialEmail } from "../../types";
import { FinancialEmailCreateService, FinancialEmailDeleteService, FinancialEmailUpdateService, FinancialEmailsService } from "../../services/financial_emails";

const FinancialEmailsPage = () => {

    const [loading, setLoading] = useState<boolean>(true);

    const [emails, setEmails] = useState<any>([]);

    // variaveis de pesquisa
    const [search, setSearch] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // variaveis de cadastro
    const [createName, setCreateName] = useState<string>('');
    const [createEmail, setCreateEmail] = useState<string>('');
    // variaveis de cadastro

    // variaveis de edição
    const [updateId, setUpdateId] = useState<number>(null!);
    const [updateName, setUpdateName] = useState<string>('');
    const [updateEmail, setUpdateEmail] = useState<string>('');
    // variaveis de edição

    // função para pesquisar os e-mails do financeiro
    const getEmails = async () => {

        setLoading(true);

        await FinancialEmailsService(search, page).then(resp => {
            setEmails(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar os e-mails do financeiro

    // função para cadastrar um e-mail do financeiro
    const createEmailFinancial = async () => {

        if (createName.length < 1 || createEmail.length < 1) {
            ToastErro('Preencha todos os campos!');
            return;
        }

        (window as any).$("#modalCreate").modal('hide');

        setLoading(true);

        await FinancialEmailCreateService(createName, createEmail).then(resp => {
            setCreateName('');
            setCreateEmail('');
            ToastSucesso(resp.data.message);
            getEmails();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
            (window as any).$("#modalCreate").modal('show');
        });

    }
    // função para cadastrar um e-mail do financeiro

    // função para abrir o modal de edição
    const showUpdate = (e: IFinancialEmail) => {

        setUpdateId(e.id);
        setUpdateName(e.name);
        setUpdateEmail(e.email);

        (window as any).$("#modalUpdate").modal('show');

    }
    // função para abrir o modal de edição

    // função para editar um e-mail do financeiro
    const updateEmailFinancial = async () => {

        if (updateName.length < 1 || updateEmail.length < 1) {
            ToastErro('Preencha todos os campos!');
            return;
        }

        (window as any).$("#modalUpdate").modal('hide');

        setLoading(true);

        await FinancialEmailUpdateService(updateId, updateName, updateEmail).then(resp => {
            ToastSucesso(resp.data.message);
            getEmails();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
            (window as any).$("#modalUpdate").modal('show');
        });

    }
    // função para editar um e-mail do financeiro

    // função para desativar/ativar um e-mail do financeiro
    const disableEmail = async (id: number) => {

        (window as any).$("#modalDisabled" + id).modal('hide');

        setLoading(true);

        await FinancialEmailDeleteService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getEmails();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para desativar/ativar um e-mail do financeiro

    useEffect(() => {
        getEmails();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="E-mails do Financeiro"
                button="E-mail"
                iconButton="add"
                onClick={() => (window as any).$("#modalCreate").modal('show')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Pesquisar"
                                col={8}
                                defaultValue={search}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                                size={"small"}
                            />
                            <div className="col-md-4">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getEmails()}>Pesquisar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <div className="row gx-5">
                        <div className="col-xl-12 col-lg-12 mb-4">
                            <div className="alert alert-info" role="alert">
                                Os e-mails ativos desta lista são os destinatários da notificação enviada quando uma ordem é liberada para pagamento.
                            </div>
                        </div>
                    </div>

                    <TableComponent
                        title="E-mails do Financeiro"
                        columns={['ID', 'Nome', 'E-mail', 'Ativo', 'Ações']}
                        loading={loading}
                        last_page={emails?.last_page}
                        page={page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            emails?.data?.map((e: IFinancialEmail) => {
                                return (
                                    <tr key={e.id}>
                                        <td className="px-4">{e.id}</td>
                                        <td className="px-4">{e.name}</td>
                                        <td className="px-4">{e.email}</td>
                                        <td className="px-4">
                                            {
                                                e.active == 1

                                                    ?

                                                    <h5><span className="badge bg-success">Sim</span></h5>

                                                    :

                                                    <h5><span className="badge bg-danger">Não</span></h5>
                                            }
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-warning" type="button" title="Editar" onClick={() => showUpdate(e)}><i className="material-icons">edit</i></button>
                                            <button className="btn btn-text-danger" type="button" title={e.active == 1 ? 'Desativar' : 'Ativar'} onClick={() => (window as any).$(`#modalDisabled${e.id}`).modal('show')}><i className="material-icons">{e.active == 1 ? 'delete' : 'upload'}</i></button>

                                            <ModalComponent
                                                title={e.active == 1 ? 'Desativar E-mail' : 'Ativar E-mail'}
                                                id={`modalDisabled${e.id}`}
                                            >
                                                <>
                                                    <p>
                                                        {
                                                            e.active == 1
                                                                ? 'Você tem certeza que deseja desativar o e-mail abaixo? Ele deixará de receber as notificações de ordens liberadas para pagamento.'
                                                                : 'Você tem certeza que deseja ativar o e-mail abaixo? Ele voltará a receber as notificações de ordens liberadas para pagamento.'
                                                        }
                                                    </p>
                                                    <table className="table mt-4">
                                                        <tbody>
                                                            <tr>
                                                                <td>Nome:</td>
                                                                <td>{e.name}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>E-mail:</td>
                                                                <td>{e.email}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => disableEmail(e.id)}>{e.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>

                    <ModalComponent
                        title="Cadastrar E-mail"
                        id="modalCreate"
                    >
                        <>
                            <div className="row mt-3">
                                <InputComponent
                                    label="Nome"
                                    col={12}
                                    defaultValue={createName}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCreateName(e.target.value)}
                                />
                            </div>
                            <div className="row">
                                <InputComponent
                                    label="E-mail"
                                    col={12}
                                    type={'email'}
                                    defaultValue={createEmail}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCreateEmail(e.target.value)}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="button" onClick={createEmailFinancial}>Cadastrar</button>
                            </div>
                        </>
                    </ModalComponent>

                    <ModalComponent
                        title="Editar E-mail"
                        id="modalUpdate"
                    >
                        <>
                            <div className="row mt-3">
                                <InputComponent
                                    key={`updateName${updateId}`}
                                    label="Nome"
                                    col={12}
                                    defaultValue={updateName}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setUpdateName(e.target.value)}
                                />
                            </div>
                            <div className="row">
                                <InputComponent
                                    key={`updateEmail${updateId}`}
                                    label="E-mail"
                                    col={12}
                                    type={'email'}
                                    defaultValue={updateEmail}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setUpdateEmail(e.target.value)}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="button" onClick={updateEmailFinancial}>Salvar</button>
                            </div>
                        </>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default FinancialEmailsPage;
